export default __webpack_public_path__ + "static/home_hero_image_mobile-01160abb8720d4475f28a2dc4a9c1b3a.png";